import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from "../auth.service";
import { CommonDataSharingService } from "../common-data-sharing.service";
import { ApiCallsService } from "./api-calls.service";
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  private readonly SECRET_KEY: string = 'IM1s5OqAYE9XoNyr7txjPXiuDO2WoZCt';
  private readonly SECRET_IV: string = 'ST9KKWIeZtw0Onu1';

  constructor(private _apiCallService: ApiCallsService, private _authService: AuthService, private _commonDataService: CommonDataSharingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem("adminToken") ? localStorage.getItem("adminToken") : "";
    if (token)
      req = req.clone({ headers: req.headers.set("authorization", atob(token)) });

    if (this._apiCallService.showLoader) this._apiCallService.loader(true);
    else this._apiCallService.showLoader = true;
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this._apiCallService.loader(false);
            return
          }
        },
        (err: any) => {
          this._apiCallService.loader(false);
          if (err instanceof HttpErrorResponse) {
            let path = window.location.pathname
            const decryptError: any = this._commonDataService.decryptData(err.error);
            if (decryptError.statusCode == 401) // 401 Unauthorized
              this._apiCallService.errorAlert(decryptError.message, true, '');
            else this._apiCallService.errorAlert(decryptError.message, false, '');
          }
        })
    );
  }




  // ------------------------ Interceptor with Encrypt/Decrypt -----------------------------------

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   const token = localStorage.getItem("adminToken") ? localStorage.getItem("adminToken") : "";
  //   if (token) {
  //     req = req.clone({ headers: req.headers.set("authorization", atob(token)) });
  //   }

  //   // Encrypt request body if present
  //   if (req.body) {
  //     const encryptedBody = this.encryptData(req.body);
  //     req = req.clone({
  //       body: encryptedBody
  //     });
  //     console.log(req, "----req");
  //   }

  //   if (this._apiCallService.showLoader) this._apiCallService.loader(true);
  //   else this._apiCallService.showLoader = true;

  //   return next.handle(req).pipe(
  //     tap(
  //       async (event: HttpEvent<any>) => {
  //         if (event instanceof HttpResponse) {
  //           console.log("event---", event);
  //           if (event.body) {
  //             // Wait for decryption to complete
  //             const decryptedBody: any = await this.decryptData(event.body);
  //             console.log('decryptedBody----', decryptedBody);

  //             // Return the modified response with the decrypted body
  //             return event.clone({ body: decryptedBody });
  //           }

  //         }
  //         return
  //       },
  //       (err: any) => {
  //         this._apiCallService.loader(false);
  //         if (err instanceof HttpErrorResponse) {
  //           let path = window.location.pathname;
  //           // Decrypt the API error response
  //           const decryptedError: any = this.decryptData(err.error);
  //           if (err.status === 401) {
  //             this._apiCallService.errorAlert(decryptedError.message, true, '');
  //           } else {
  //             this._apiCallService.errorAlert(decryptedError.message, false, '');
  //           }
  //         }
  //       }
  //     )
  //   );
  // }

  // decryptData(apiRes: string): string {
  //   const secretKey = CryptoJS.enc.Utf8.parse(this.SECRET_KEY); // 32 bytes
  //   const iv = CryptoJS.enc.Utf8.parse(this.SECRET_IV); // 16 bytes
  //   // Decrypt the encrypted text
  //   const decrypted = CryptoJS.AES.decrypt(apiRes, secretKey, {
  //     iv: iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7
  //   });

  //   const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  //   return JSON.parse(decryptedText); // Convert JSON string back to an object
  // }

  // encryptData(data: string): string {
  //   const secretKey = CryptoJS.enc.Utf8.parse(this.SECRET_KEY); // 32 bytes
  //   const iv = CryptoJS.enc.Utf8.parse(this.SECRET_IV); // 16 bytes
  //   // Convert data to JSON string
  //   const stringifyJsonData = JSON.stringify(data);

  //   // Encrypt the JSON string
  //   const encrypted = CryptoJS.AES.encrypt(
  //     CryptoJS.enc.Utf8.parse(stringifyJsonData), // Convert string to WordArray
  //     secretKey,
  //     {
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7,
  //     }
  //   );

  //   // Return encrypted data as a Base64 string
  //   return encrypted.toString();
  // }

}
